// extracted by mini-css-extract-plugin
module.exports = {"container":"searchResult_container__1f94X","result":"searchResult_result__1FrNW","words":"searchResult_words__VKPJz"};